import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
  const pxToRem = (px: number): string => `${px / 16}rem`;
  return{
  title: {
    textAlign: 'center',
    margin: `0 auto ${pxToRem(22)}`,
  },
}});

export default useStyles;
